import PropTypes from 'prop-types';
import { Component } from 'react';
import { NumberFormatBase } from 'react-number-format';
import { connect } from 'react-redux';
import { getCurrencyFormatProps } from '../../utils/NumberUtils';
import CustomTextField from './../CustomTextField/CustomTextField';

class CustomCurrencyField extends Component {
  getCustomInput = (customInputProps) => {
    let customProps = {
      ...this.props,
      ...customInputProps,
    };
    delete customProps.inputMode;
    delete customProps.allowEmpty;
    customProps.value = customInputProps.value;
    if (
      customProps.value.indexOf(
        this.props.languageValues.currencyPrefix + ','
      ) > -1
    ) {
      customProps.value = customProps.value
        .split(this.props.languageValues.currencyPrefix)
        .join(this.props.languageValues.currencyPrefix + '0,');
    }
    if (
      customProps.value === '' ||
      customProps.value === 0 ||
      customProps.value === '0'
    ) {
      if (this.props.allowEmpty) {
        customProps.value = '';
      } else {
        customProps.value = this.props.languageValues.currencyPrefix + '0,00';
      }
    }
    delete customProps.dispatch;
    return <CustomTextField {...customProps} />;
  };

  render() {
    let allProps = {
      ...this.props,
    };

    return (
      <NumberFormatBase
        {...getCurrencyFormatProps(this.props.languageValues)}
        value={allProps.value}
        customInput={this.getCustomInput}
        onValueChange={(value) => {
          if (typeof allProps.onChange === 'function') {
            const newValue =
              value && typeof value.floatValue === 'number'
                ? value.floatValue
                : 0;
            allProps.onChange(newValue);
          }
        }}
      />
    );
  }
}

CustomCurrencyField.propTypes = {
  ...CustomTextField.propTypes,
  allowEmpty: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(CustomCurrencyField);
